import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Check, BookOpen, Headphones, ArrowRight } from "lucide-react";
export default function GetYourStrategy() {
  return <section data-section-id="40" id="familycard" className="bg-background text-foreground py-20 md:py-32 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-10">
        <div className="absolute -top-[20%] -right-[10%] w-[600px] h-[600px] rounded-full bg-secondary blur-[120px]" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[500px] h-[500px] rounded-full bg-primary blur-[100px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          <h2 className="text-3xl md:text-5xl font-default font-bold tracking-tight text-primary">
            Garanta a Saúde de Toda a Sua Família
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed max-w-3xl mx-auto">Na Clínica Santa Cruz, oferecemos um acompanhamento médico de excelência para todas as gerações, combinando tecnologia avançada com um atendimento humano e personalizado para o bem-estar da sua família.<br /><br />Ao aderir, todos os membros usufruem de 10% de desconto nas consultas, para além de um atendimento mais célere e diferenciado.</p>
          <img src="https://clinica-santa-cruz.pt/wp-content/uploads/2026/04/Untitled-design-1.png" alt="Família sorridente recebendo cuidados de saúde preventiva na Clínica Santa Cruz" className="w-full max-w-3xl mx-auto rounded-2xl shadow-xl object-cover aspect-video" />
        </div>
      </div>
    </section>;
}